import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
	const rentalBtn = document.getElementById('rental-js');
	const rentalContent = document.querySelector(
		'.contents--prices--imgs.rental'
	);

	// 初期状態を設定
	rentalContent.style.height = '0';
	rentalContent.style.overflow = 'hidden';
	rentalContent.style.transition = 'height 0.3s ease-in-out';

	rentalBtn.addEventListener('click', () => {
		const isExpanded = rentalBtn.classList.contains('is-open');

		if (!isExpanded) {
			// 開く
			const contentHeight = rentalContent.scrollHeight;
			rentalContent.style.height = contentHeight + 'px';
			rentalBtn.classList.add('is-open');
			rentalBtn.querySelector('span').textContent = '閉じる';
		} else {
			// 閉じる
			rentalContent.style.height = '0';
			rentalBtn.classList.remove('is-open');
			rentalBtn.querySelector('span').textContent = '詳しく見る';
		}
	});

	const faqItems = document.querySelectorAll('.faq-accordion dt');

	faqItems.forEach((dt) => {
		dt.addEventListener('click', () => {
			const dd = dt.nextElementSibling; // 対応するdd要素を取得

			// dtのクラスとddの表示を切り替え
			dt.classList.toggle('open');
			dd.classList.toggle('open');

			// アニメーションのためのスタイル設定
			if (dt.classList.contains('open')) {
				dd.style.height = dd.scrollHeight + 'px';
			} else {
				dd.style.height = '0';
			}
		});
	});

	// テキスト制限の処理を関数化
	function handleClampText() {
		// ウィンドウ幅が768px以下の場合のみ処理を実行
		const isMobile = window.innerWidth <= 768;

		document.querySelectorAll('.clamp-text').forEach((el) => {
			// ボタン要素を取得
			let btn = el.closest('.card').querySelector('.voice-more-btn');

			// PC表示では全表示にする（769px以上）
			if (!isMobile) {
				el.classList.remove('is-limited');
				btn.classList.remove('is-disp');
				return;
			}

			// モバイル表示では制限をかける（768px以下）
			el.classList.add('is-limited');

			let lines = 5; // 5行まで表示
			let lineHeight = parseFloat(getComputedStyle(el).lineHeight);
			let maxHeight = lineHeight * lines;

			if (el.scrollHeight > maxHeight) {
				// ボタンを表示
				btn.classList.add('is-disp');

				// イベントリスナーが既に設定されているかチェック
				if (!btn.hasAttribute('data-listener-added')) {
					btn.setAttribute('data-listener-added', 'true');
					btn.addEventListener('click', () => {
						el.classList.toggle('is-open');
						btn.classList.toggle('is-open');
						// テキストの変更
						if (el.classList.contains('is-open')) {
							btn.innerText = '閉じる'; // is-open が付与されている場合
						} else {
							btn.innerText = '続きを見る'; // is-open が外れた場合
						}
					});
				}
			} else {
				// 制限高さを超えていない場合はボタンを非表示に
				btn.classList.remove('is-disp');
			}
		});
	}

	// ページ読み込み時に実行
	handleClampText();

	// リサイズ時にも実行（デバウンス処理付き）
	let resizeTimer;
	window.addEventListener('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(handleClampText, 200);
	});

	// メディアクエリの変更を監視（768pxのブレイクポイント）
	const mediaQueryList = window.matchMedia('(max-width: 768px)');
	mediaQueryList.addEventListener('change', handleClampText);

	// document.querySelectorAll('.clamp-text').forEach((el) => {
	// 	let lines = 5; // 5行まで表示
	// 	let lineHeight = parseFloat(getComputedStyle(el).lineHeight);
	// 	let maxHeight = lineHeight * lines;

	// 	if (el.scrollHeight > maxHeight) {
	// 		console.log('el.scrollHeight', el.scrollHeight);
	// 		let btn = el.closest('.card').querySelector('.voice-more-btn');
	// 		btn.classList.add('is-disp');
	// 		btn.addEventListener('click', () => {
	// 			el.classList.toggle('is-open');
	// 			btn.classList.toggle('is-open');
	// 			// テキストの変更
	// 			if (el.classList.contains('is-open')) {
	// 				btn.innerText = '閉じる'; // is-open が付与されている場合
	// 			} else {
	// 				btn.innerText = '続きを見る'; // is-open が外れた場合
	// 			}
	// 		});
	// 	}
	// });
	const instructorElement = document.querySelector('#splideInstructor');
	if (instructorElement) {
		const splide = new Splide('#splideInstructor', {
			type: 'loop',
			perPage: 1,
			gap: '2rem',
			pagination: true,
		});
		splide.mount();
		// カスタム分数ページネーション(インストラクター)
		const fractionPagination = document.createElement('div');
		fractionPagination.classList.add('fraction-pagination');
		splide.root.appendChild(fractionPagination);

		// 分数形式の更新関数
		const updatePagination = () => {
			const total = splide.length;
			const current = splide.index + 1;
			fractionPagination.innerHTML = `<span>${current}</span><span>/</span>${total}`;
		};
		// 初期表示を設定
		updatePagination();
		// スライド移動時のイベントリスナー
		splide.on('moved', updatePagination);
	}

	const nearElement = document.querySelector('#splideNear');
	if (nearElement) {
		const splide2 = new Splide('#splideNear', {
			type: 'loop',
			perPage: 1,
			gap: '20px',
			pagination: true,
			destroy: true,
			breakpoints: {
				768: {
					destroy: false, // 500px未満でスライダー開始
				},
			},
		});
		splide2.mount();
		// カスタム分数ページネーション(インストラクター)
		const fractionPagination2 = document.createElement('div');
		fractionPagination2.classList.add('fraction-pagination2');
		splide2.root.appendChild(fractionPagination2);

		// 分数形式の更新関数
		const updatePagination2 = () => {
			const total = splide2.length;
			const current = splide2.index + 1;
			fractionPagination2.innerHTML = `<span>${current}</span><span>/</span>${total}`;
		};
		updatePagination2();
		// スライド移動時のイベントリスナー
		splide2.on('moved', updatePagination2);
	}
});
